import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_FORMTEMPLATES_LOAD,
    ACTION_FORMTEMPLATES_LOAD_BY_ID,
    ACTION_FORMTEMPLATES_LOAD_FAILURE,
    ACTION_FORMTEMPLATES_LOAD_SUCCESS,

    ACTION_FORMTEMPLATES_SAVE,
    ACTION_FORMTEMPLATES_SAVE_SUCCESS,
    ACTION_FORMTEMPLATES_SAVE_FAILURE,

    ACTION_FORMTEMPLATES_CREATE,
    ACTION_FORMTEMPLATES_CREATE_SUCCESS,
    ACTION_FORMTEMPLATES_CREATE_FAILURE,

    ACTION_FORMTEMPLATES_VALIDATE,
    ACTION_FORMTEMPLATES_VALIDATE_SUCCESS,
    ACTION_FORMTEMPLATES_VALIDATE_FAILURE,

    ACTION_FORMTEMPLATES_CLEAR,
    ACTION_FORMTEMPLATES_FILTER,

    FormTemplateAction
} from '../actions/formTemplates';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";


export interface IFormTemplateState {
    formData: Dtos.FormTemplate | Dtos.FormTemplate[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[];
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.FormTemplate[];
}

const initialState: IFormTemplateState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: []
};


function loading(state: IFormTemplateState, _isLoading: boolean): IFormTemplateState {
    const newState: IFormTemplateState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: IFormTemplateState,
    formData: Dtos.FormTemplate | Dtos.FormTemplate[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): IFormTemplateState {
    const newState: IFormTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: IFormTemplateState, formFilter: IFormFilter): IFormTemplateState {

    const institutiontypes: Dtos.FormTemplate[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formFilteredData = institutiontypes ? institutiontypes.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    const newState: IFormTemplateState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        }
    });

    return newState;
}

function loadFailure(state: IFormTemplateState, responseStatus: Dtos.ResponseStatus): IFormTemplateState {
    const newState: IFormTemplateState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IFormTemplateState, propertiesToClear?: string[]): IFormTemplateState {

    if (!propertiesToClear) {
        let formFilter = state.formFilter;
        const newState: IFormTemplateState = update(initialState, {
            formFilter: {
                $set: formFilter
            }
        });
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: IFormTemplateState, _isSaving: boolean): IFormTemplateState {
    const newState: IFormTemplateState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IFormTemplateState,
    formData: Dtos.FormTemplate | Dtos.FormTemplate[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IFormTemplateState {
    const newState: IFormTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IFormTemplateState, responseStatus: Dtos.ResponseStatus): IFormTemplateState {
    const newState: IFormTemplateState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: IFormTemplateState, _isCreating: boolean): IFormTemplateState {
    const newState: IFormTemplateState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IFormTemplateState,
    formData: Dtos.FormTemplate,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): IFormTemplateState {
    const newState: IFormTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IFormTemplateState, responseStatus: Dtos.ResponseStatus): IFormTemplateState {
    const newState: IFormTemplateState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: IFormTemplateState, _isValidating: boolean): IFormTemplateState {
    const newState: IFormTemplateState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: IFormTemplateState,
    formData: Dtos.FormTemplate,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): IFormTemplateState {
    const newState: IFormTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: IFormTemplateState, responseStatus: Dtos.ResponseStatus): IFormTemplateState {
    const newState: IFormTemplateState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const FormTemplateReducer: Reducer<IFormTemplateState> = (state: IFormTemplateState = initialState, action: FormTemplateAction) => {
    switch (action.type) {
        case ACTION_FORMTEMPLATES_LOAD:
        case ACTION_FORMTEMPLATES_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_FORMTEMPLATES_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_FORMTEMPLATES_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_FORMTEMPLATES_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_FORMTEMPLATES_SAVE:
            return saving(state, true);
        case ACTION_FORMTEMPLATES_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_FORMTEMPLATES_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_FORMTEMPLATES_CREATE:
            return creating(state, true);
        case ACTION_FORMTEMPLATES_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_FORMTEMPLATES_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_FORMTEMPLATES_VALIDATE:
            return validating(state, true);
        case ACTION_FORMTEMPLATES_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_FORMTEMPLATES_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_FORMTEMPLATES_FILTER:
            return filter(state, action.formFilter);

    }

    return state;
}

export default FormTemplateReducer;